import { render, staticRenderFns } from "./widget-smc-event-register.vue?vue&type=template&id=6eed8918&scoped=true"
import script from "./widget-smc-event-register.vue?vue&type=script&lang=ts"
export * from "./widget-smc-event-register.vue?vue&type=script&lang=ts"
import style0 from "./widget-smc-event-register.vue?vue&type=style&index=0&id=6eed8918&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eed8918",
  null
  
)

export default component.exports